// extracted by mini-css-extract-plugin
export default {"container":"style_container__qU97E","ball":"style_ball__5SlIH","checked":"style_checked__yEJqP"};